import React, { useState, useEffect } from 'react';
import dynamic from 'next/dynamic';
import { Row, Col, Alert, Button } from 'react-bootstrap';

const Chart = dynamic(() => import('react-apexcharts'), { ssr: false });

export default function FiyatGrafik({ fiyatlar: initialFiyatlar, fonID }) {
  const [paraBirimi, setParaBirimi] = useState('TL');
  const [fiyatlar, setFiyatlar] = useState([]);
  const [selectedOption, setSelectedOption] = useState('getiri_1y');

  useEffect(() => {
    if (Array.isArray(initialFiyatlar) && initialFiyatlar.length > 0) {
      setFiyatlar(initialFiyatlar);
    }
  }, [initialFiyatlar]);

  useEffect(() => {
    const fetchData = async () => {
      const url = `https://api.yatirimnedir.com/fon-fiyat.php?fonID=${fonID}&paraBirimi=${paraBirimi}&getiri=${selectedOption}`;
      try {
        const response = await fetch(url);
        const data = await response.json();
        if (Array.isArray(data.fiyatlar)) {
          setFiyatlar([...data.fiyatlar]); // Yeni bir dizi oluşturarak state güncelleme
        } else {
          console.error('Veri dizi olarak dönmedi:', data);
        }
      } catch (error) {
        console.error('API veri çekme hatası:', error);
      }
    };
  
    fetchData();
  }, [paraBirimi, fonID]); // Bağımlılıkları kontrol et

  const handleOptionChange = (event) => {
    const selectedValue = event.target.id;
    setSelectedOption(selectedValue);
    sendApiRequest(selectedValue);
  };

  const sendApiRequest = (selectedValue) => {
    const url = `https://api.yatirimnedir.com/fon-fiyat.php?fonID=${fonID}&paraBirimi=${paraBirimi}&getiri=${selectedValue}`;
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        if (Array.isArray(data.fiyatlar)) {
          setFiyatlar([...data.fiyatlar]); // Yeni bir dizi oluşturarak state güncelleme
        } else {
          console.error('Veri dizi olarak dönmedi:', data);
        }
      })
      .catch((error) => {
        console.error('API isteği hatası:', error);
      });
  };

  const handleCurrencyChange = (currency) => {
    setParaBirimi(currency);
  };

  if (!Array.isArray(fiyatlar) || fiyatlar.length === 0) {
    return (
      <Row className='mb-4'>
        <Col>
          <div className='card-shadow'>
            <div className='px-4 pt-4 pb-2 d-flex align-items-center justify-content-between'>
              <div className='d-flex align-items-center'>
                <h2 className='h6 m-0 me-4'>Fiyat Grafiği</h2>
              </div>
            </div>
            <hr/>
            <div className='p-4 pb-2 pt-2'>
              <Alert variant='warning'>
                Fiyat verileri mevcut değil.
              </Alert>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
  

  const fiyatlarChartOptions = {
    chart: {
      id: 'price-trend',
      toolbar: {
        show: false
      },
      zoom: {
        enabled: false
      }
    },
    colors: ['#5151F9'],
    xaxis: {
      categories: fiyatlar.map(data => data.tarih),
      labels: {
        show: false
      },
      axisTicks: {
        show: false
      },
      axisBorder: {
        show: false
      }
    },
    yaxis: {
      labels: {
        show: false
      }
    },
    grid: {
      show: false
    },
    dataLabels: {
      enabled: false
    },
    stroke: {
      curve: 'smooth',
      width: 2,
      lineCap: 'round',
      show: true,
    },
    fill: {
      type: "gradient",
      gradient: {
        shade: 'light',
        shadeIntensity: 0.6,
        opacityFrom: 0.6,
        opacityTo: 0,
      }
    },
  };

  const fiyatlarChartSeries = [{
    name: 'Fiyat',
    data: fiyatlar.map(data => parseFloat(data.fiyat))
  }];

  return (
    <Row className='mb-4'>
      <Col>
        <div className='card-shadow'>
          <div className='px-4 pt-4 pb-0'>
            <Row className='d-flex align-items-center'>
              <Col xl={4} className='mb-2'>
                <div className='d-flex align-items-center'>
                  <h2 className='h6 m-0 me-4'>Fiyat Grafiği</h2>
                  <div>
                    <Button
                      variant={paraBirimi === 'TL' ? 'primary' : 'light'}
                      size="sm"
                      className='me-2'
                      onClick={() => handleCurrencyChange('TL')}
                    >
                      TL
                    </Button>
                    <Button
                      variant={paraBirimi === 'USD' ? 'primary' : 'light'}
                      size="sm"
                      onClick={() => handleCurrencyChange('USD')}
                    >
                      USD
                    </Button>
                  </div>
                </div>
              </Col>
              <Col xl={8} className='mb-2'>
                <div className='d-lg-flex align-items-center justify-content-end'>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_1h"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_1h'}
                    />
                    <label htmlFor="getiri_1h">1 Hafta</label>
                  </div>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_1a"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_1a'}
                    />
                    <label htmlFor="getiri_1a">1 Ay</label>
                  </div>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_3a"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_3a'}
                    />
                    <label htmlFor="getiri_3a">3 Ay</label>
                  </div>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_6a"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_6a'}
                    />
                    <label htmlFor="getiri_6a">6 Ay</label>
                  </div>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_yb"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_yb'}
                    />
                    <label htmlFor="getiri_yb">YBB</label>
                  </div>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_1y"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_1y'}
                    />
                    <label htmlFor="getiri_1y">1 Yıl</label>
                  </div>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_3y"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_3y'}
                    />
                    <label htmlFor="getiri_3y">3 Yıl</label>
                  </div>
                  <div className="radiobox radiobox-primary ms-4">
                    <input
                      type="radio"
                      name="check0"
                      id="getiri_5y"
                      onChange={handleOptionChange}
                      checked={selectedOption === 'getiri_5y'}
                    />
                    <label htmlFor="getiri_5y">5 Yıl</label>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
          <hr/>
          <div className='p-sm-0 p-lg-4 pt-0'>
            <Chart
              options={fiyatlarChartOptions}
              series={fiyatlarChartSeries}
              type='area'
              width='100%'
              height='300'
            />
            {paraBirimi === 'USD' &&
              <Alert variant='warning'>
                Eğer grafik içinde 0.000000 olan bir fiyat varsa, sistemimizde o güne ait veri eksik olduğu içindir!
              </Alert>
            }
          </div>
        </div>
      </Col>
    </Row>
  );
}
